<div class="whatsapp-dialog flex flex-col gap-4">
  @if (contactName) {
    <p class="dialog-message" id="whatsapp-dialog-contact-name">
      {{ 'whatsapp_dialog.sending_to' | translate }} <strong>{{ contactName }}</strong>
    </p>
  }

  <div class="flex flex-col gap-1.5">
    <div class="flex items-center justify-between gap-2">
      <label class="field-label" id="label-whatsapp-dialog-phone" for="whatsapp-dialog-phone-input">
        {{ 'whatsapp_dialog.fields.phone' | translate }}
        <span class="required-asterisk">*</span>
      </label>
      <button
        type="button"
        class="whatsapp-dialog-help-btn"
        id="whatsapp-dialog-phone-help-button"
        [attr.aria-label]="'whatsapp_dialog.phone_help_tooltip' | translate"
        [appTippy]="'whatsapp_dialog.phone_help_tooltip' | translate"
        [tippyOptions]="{ placement: 'top' }"
      >
        <mat-icon>help_outline</mat-icon>
      </button>
    </div>
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-icon matPrefix class="field-prefix-icon">phone</mat-icon>
      <input
        #phoneInput
        id="whatsapp-dialog-phone-input"
        matInput
        [formControl]="phoneControl"
        appPhoneMask
        type="tel"
        [readonly]="!isEditingPhone()"
        [class.locked]="!isEditingPhone()"
        [placeholder]="'whatsapp_dialog.placeholders.phone' | translate"
      />
      @if (phoneControl.touched && phoneControl.hasError('required')) {
        <mat-error id="whatsapp-dialog-phone-required-error">{{ 'validation.errors.required_field' | translate }}</mat-error>
      } @else if (phoneControl.touched && phoneControl.hasError('invalidPhone')) {
        <mat-error id="whatsapp-dialog-phone-invalid-error">{{ 'whatsapp_dialog.errors.invalid_phone' | translate }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="flex flex-col gap-1.5">
    <label class="field-label" id="label-whatsapp-dialog-message" for="whatsapp-dialog-message-input">
      {{ 'whatsapp_dialog.fields.message' | translate }}
    </label>
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <textarea id="whatsapp-dialog-message-input" matInput rows="6" [formControl]="messageControl"></textarea>
    </mat-form-field>
  </div>

  <p class="dialog-hint flex items-center gap-1.5" id="whatsapp-dialog-hint">
    <mat-icon class="hint-icon">info</mat-icon>
    {{ 'whatsapp_dialog.hint' | translate }}
  </p>

  <div class="form-divider" aria-hidden="true"></div>
  <div class="flex justify-end gap-2 shrink-0">
    <button type="button" class="btn-secondary" id="whatsapp-dialog-cancel-button" (click)="onCancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn-primary" id="whatsapp-dialog-open-button" (click)="openWhatsapp()">
      <mat-icon>open_in_new</mat-icon>
      {{ 'whatsapp_dialog.actions.open_whatsapp' | translate }}
    </button>
  </div>
</div>
